// import React, { useState, useEffect } from "react";
// import { Box, Container, Grid, Typography, Button, Chip } from "@mui/material";
// import AnimatedSection from "../common/AnimatedSection";

// const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const CREAM = "#FFF8F0"; const PURPLE = "#845EF7";

// /* Animated inline SVG: kids at school, flat retro cartoon */
// const HeroIllustration = () => (
//   <svg viewBox="0 0 480 380" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 480, height: "auto" }}>
//     {/* Sky background */}
//     <rect width="480" height="380" rx="24" fill="#E8F4FF"/>
//     {/* Clouds */}
//     <ellipse cx="80" cy="60" rx="45" ry="22" fill="#fff"/>
//     <ellipse cx="110" cy="50" rx="35" ry="20" fill="#fff"/>
//     <ellipse cx="55" cy="55" rx="30" ry="18" fill="#fff"/>
//     <ellipse cx="360" cy="50" rx="50" ry="24" fill="#fff"/>
//     <ellipse cx="395" cy="40" rx="36" ry="20" fill="#fff"/>
//     <ellipse cx="335" cy="48" rx="30" ry="18" fill="#fff"/>
//     {/* Sun */}
//     <circle cx="420" cy="70" r="30" fill={YELLOW} style={{ animation: "pulse 3s ease-in-out infinite" }}/>
//     <circle cx="420" cy="70" r="24" fill="#FFE566"/>
//     {/* School building */}
//     <rect x="140" y="140" width="200" height="160" rx="4" fill="#fff" stroke={NAVY} strokeWidth="3"/>
//     <rect x="160" y="90" width="160" height="55" fill={CORAL} stroke={NAVY} strokeWidth="3"/>
//     <polygon points="240,55 160,90 320,90" fill={NAVY}/>
//     {/* Flag */}
//     <rect x="238" y="30" width="3" height="30" fill={NAVY}/>
//     <rect x="241" y="30" width="22" height="14" fill={CORAL}/>
//     {/* Windows */}
//     {[[160,160],[210,160],[260,160],[160,210],[260,210]].map(([x,y],i)=>(
//       <rect key={i} x={x} y={y} width="35" height="30" rx="4" fill="#C8F5FF" stroke={NAVY} strokeWidth="2"/>
//     ))}
//     {/* Door */}
//     <rect x="213" y="235" width="54" height="65" rx="6" fill={TEAL} stroke={NAVY} strokeWidth="2.5"/>
//     <circle cx="260" cy="270" r="4" fill={YELLOW}/>
//     {/* Sign */}
//     <rect x="175" y="183" width="65" height="20" rx="4" fill={YELLOW} stroke={NAVY} strokeWidth="2"/>
//     <text x="208" y="198" textAnchor="middle" fontFamily="Fredoka One, cursive" fontSize="9" fill={NAVY}>ST LORD'S</text>
//     {/* Ground */}
//     <rect x="0" y="300" width="480" height="80" rx="0" fill={TEAL}/>
//     <rect x="0" y="295" width="480" height="10" fill="#04B87C"/>
//     {/* Fence */}
//     {[70,110,380,420].map((x,i)=>(
//       <rect key={i} x={x} y="270" width="8" height="35" rx="2" fill={NAVY}/>
//     ))}
//     <rect x="70" y="268" width="70" height="5" rx="2" fill={NAVY}/>
//     <rect x="370" y="268" width="60" height="5" rx="2" fill={NAVY}/>
//     {/* Tree left */}
//     <rect x="55" y="220" width="12" height="50" rx="4" fill="#8B6914"/>
//     <ellipse cx="61" cy="210" rx="30" ry="32" fill="#2ECC71"/>
//     <ellipse cx="61" cy="210" rx="22" ry="24" fill="#27AE60"/>
//     {/* Tree right */}
//     <rect x="413" y="220" width="12" height="50" rx="4" fill="#8B6914"/>
//     <ellipse cx="419" cy="210" rx="30" ry="32" fill="#2ECC71"/>
//     <ellipse cx="419" cy="210" rx="22" ry="24" fill="#27AE60"/>
//     {/* Kid 1 - bouncing */}
//     <g style={{ animation: "bounce 1.8s ease-in-out infinite", transformOrigin: "80px 300px" }}>
//       <circle cx="80" cy="280" r="14" fill="#FDBCB4"/>
//       <rect x="68" y="293" width="24" height="26" rx="6" fill={CORAL}/>
//       <rect x="66" y="293" width="10" height="18" rx="4" fill={CORAL}/>
//       <rect x="82" y="293" width="10" height="18" rx="4" fill={CORAL}/>
//       <rect x="70" y="318" width="10" height="16" rx="4" fill={NAVY}/>
//       <rect x="82" y="318" width="10" height="16" rx="4" fill={NAVY}/>
//       {/* Bag */}
//       <rect x="88" y="296" width="14" height="18" rx="4" fill={YELLOW} stroke={NAVY} strokeWidth="1.5"/>
//     </g>
//     {/* Kid 2 - wiggling */}
//     <g style={{ animation: "wiggle 2s ease-in-out infinite", transformOrigin: "390px 300px" }}>
//       <circle cx="390" cy="278" r="14" fill="#FDBCB4"/>
//       <rect x="378" y="291" width="24" height="26" rx="6" fill={PURPLE}/>
//       <rect x="376" y="291" width="10" height="18" rx="4" fill={PURPLE}/>
//       <rect x="392" y="291" width="10" height="18" rx="4" fill={PURPLE}/>
//       <rect x="380" y="316" width="10" height="16" rx="4" fill={NAVY}/>
//       <rect x="392" y="316" width="10" height="16" rx="4" fill={NAVY}/>
//       <rect x="376" y="294" width="14" height="18" rx="4" fill={TEAL} stroke={NAVY} strokeWidth="1.5"/>
//     </g>
//     {/* Stars */}
//     <text x="30" y="120" fontSize="20" style={{ animation: "starSpin 3s linear infinite" }}>⭐</text>
//     <text x="440" y="130" fontSize="16" style={{ animation: "starSpin 4s linear infinite reverse" }}>✨</text>
//     <text x="200" y="40" fontSize="14" style={{ animation: "floatY 2s ease-in-out infinite" }}>🎒</text>
//     <text x="270" y="35" fontSize="14" style={{ animation: "floatY 2.5s ease-in-out infinite" }}>📚</text>
//   </svg>
// );

// const HeroSection = ({ slides, highlights, schoolInfo, onNavigate }) => {
//   const [tick, setTick] = useState(0);
//   useEffect(() => {
//     const t = setInterval(() => setTick(p => (p + 1) % 3), 4000);
//     return () => clearInterval(t);
//   }, []);

//   const slide = slides[tick];

//   return (
//     <Box id="hero" sx={{ backgroundColor: NAVY, overflow: "hidden", position: "relative", pt: { xs: 8, md: 10 }, pb: 0 }}>
//       {/* Decorative dots top-right */}
//       {[0,1,2,3,4].map(i => [0,1,2,3,4].map(j => (
//         <Box key={`${i}-${j}`} sx={{ position: "absolute", top: 20 + i*28, right: 20 + j*28, width: 5, height: 5, borderRadius: "50%", backgroundColor: `rgba(255,211,61,${0.08 + i*0.03})` }} />
//       )))}

//       <Container maxWidth="xl">
//         <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
//           {/* Left text */}
//           <Grid item xs={12} md={6}>
//             <Box sx={{ animation: "slideRight 0.7s ease-out both" }}>
//               {/* Badge */}
//               <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, px: 2, py: 0.75, mb: 3, borderRadius: "10px", border: `2px solid ${YELLOW}`, backgroundColor: "rgba(255,211,61,0.12)" }}>
//                 <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: TEAL, animation: "blink 1.5s ease-in-out infinite" }} />
//                 <Typography sx={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: "0.78rem", letterSpacing: "0.1em", color: YELLOW, textTransform: "uppercase" }}>
//                   {slide.badge}
//                 </Typography>
//               </Box>

//               {/* Headline */}
//               <Typography
//                 key={tick}
//                 variant="h1"
//                 sx={{ fontFamily: "'Fredoka One', cursive", fontSize: { xs: "2.4rem", sm: "3rem", md: "3.6rem", lg: "4rem" }, color: "#FFF8F0", lineHeight: 1.1, mb: 2.5, animation: "slideUp 0.5s ease-out both" }}
//               >
//                 {slide.title.split(" ").slice(0, 3).join(" ")}{" "}
//                 <Box component="span" sx={{ color: YELLOW }}>{slide.title.split(" ").slice(3, 5).join(" ")}</Box>{" "}
//                 {slide.title.split(" ").slice(5).join(" ")}
//               </Typography>

//               <Typography sx={{ color: "rgba(255,248,240,0.75)", fontWeight: 600, fontSize: { xs: "1rem", md: "1.1rem" }, lineHeight: 1.8, mb: 4, maxWidth: 520, animation: "slideUp 0.7s ease-out both" }}>
//                 {slide.description}
//               </Typography>

//               {/* CTAs */}
//               <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 5 }}>
//                 <Button
//                   variant="contained"
//                   size="large"
//                   onClick={() => onNavigate("admissions")}
//                   sx={{ px: 4, py: 1.5, fontSize: "1rem", backgroundColor: CORAL, color: "#fff", border: `2.5px solid ${YELLOW}`, boxShadow: `4px 4px 0 ${YELLOW}`, "&:hover": { backgroundColor: "#FF8080", transform: "translate(-2px,-2px)", boxShadow: `6px 6px 0 ${YELLOW}` } }}
//                 >
//                   Apply Now 🎒
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   size="large"
//                   onClick={() => onNavigate("about")}
//                   sx={{ px: 4, py: 1.5, fontSize: "1rem", borderColor: TEAL, color: TEAL, boxShadow: `4px 4px 0 ${TEAL}`, "&:hover": { borderColor: TEAL, backgroundColor: "rgba(6,214,160,0.08)", transform: "translate(-2px,-2px)", boxShadow: `6px 6px 0 ${TEAL}` } }}
//                 >
//                   Explore School
//                 </Button>
//               </Box>

//               {/* Slide dots */}
//               <Box sx={{ display: "flex", gap: 1 }}>
//                 {slides.map((_, i) => (
//                   <Box key={i} component="button" onClick={() => setTick(i)} sx={{ width: i === tick ? 28 : 10, height: 10, borderRadius: 999, backgroundColor: i === tick ? YELLOW : "rgba(255,211,61,0.3)", border: "none", cursor: "pointer", transition: "all 0.3s ease", p: 0 }} />
//                 ))}
//               </Box>
//             </Box>
//           </Grid>

//           {/* Right illustration */}
//           <Grid item xs={12} md={6}>
//             <Box sx={{ animation: "floatYSlow 4s ease-in-out infinite", position: "relative" }}>
//               <HeroIllustration />
//             </Box>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Stats bar */}
//       <Box sx={{ mt: 6, borderTop: `3px solid rgba(255,211,61,0.2)`, backgroundColor: "rgba(255,211,61,0.06)", py: 3 }}>
//         <Container maxWidth="xl">
//           <Grid container spacing={2} justifyContent="center">
//             {highlights.map((h, i) => (
//               <Grid item xs={6} sm={3} key={i}>
//                 <Box sx={{ textAlign: "center", py: 1 }}>
//                   <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "2.2rem", color: [YELLOW, CORAL, TEAL, PURPLE][i % 4], lineHeight: 1 }}>
//                     {h.value}+
//                   </Typography>
//                   <Typography sx={{ color: "rgba(255,248,240,0.65)", fontWeight: 600, fontSize: "0.8rem", mt: 0.5 }}>{h.label}</Typography>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default HeroSection;























import React, { useState, useEffect, useCallback } from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

const NAVY = "#1B1F3B";
const CORAL = "#FF6B6B";
const YELLOW = "#FFD93D";
const TEAL = "#06D6A0";
const CREAM = "#FFF8F0";
const PURPLE = "#845EF7";

const HERO_IMAGES = [
  {
    src: "/hero-section/school-img.png",
    badge: "Academic Excellence",
    title: "Smart Classrooms",
  },
  {
    src: "/hero-section/childrens-1.png",
    badge: "Our Campus",
    title: "Beautiful Environment",
  },
  {
    src: "/hero-section/childrens-2.png",
    badge: "Sports & Play",
    title: "Active Lifestyle",
  },
];

const HeroSection = ({ slides, highlights, schoolInfo, onNavigate }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const maxLength = Math.max(slides.length, HERO_IMAGES.length);

  // Synchronized auto-rotation for both slides and images
  useEffect(() => {
    const t = setInterval(() => {
      setIsTransitioning(true);
      setCurrentIndex((prev) => (prev + 1) % maxLength);
      setTimeout(() => setIsTransitioning(false), 500);
    }, 4000);
    return () => clearInterval(t);
  }, [maxLength]);

  const slide = slides[currentIndex % slides.length];
  const currentImage = HERO_IMAGES[currentIndex % HERO_IMAGES.length];

  const handlePrevImage = useCallback(() => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev - 1 + maxLength) % maxLength);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [maxLength]);

  const handleNextImage = useCallback(() => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev + 1) % maxLength);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [maxLength]);

  const handleSlideDotClick = (index) => {
    setIsTransitioning(true);
    setCurrentIndex(index);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  return (
    <Box id="hero" sx={{
      backgroundColor: CREAM,
      overflow: "hidden",
      position: "relative",
      pt: { xs: 10, md: 12 },
      pb: 0,
    }}>
      {/* Decorative background elements */}
      <Box sx={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, borderRadius: "50%", backgroundColor: YELLOW, border: `4px solid ${NAVY}`, opacity: 0.06 }} />
      <Box sx={{ position: "absolute", bottom: "20%", left: -50, width: 200, height: 200, borderRadius: "50%", backgroundColor: TEAL, border: `3px solid ${NAVY}`, opacity: 0.06 }} />
      <Box sx={{ position: "absolute", top: "30%", left: "5%", fontSize: "50px", opacity: 0.05, animation: "floatY 4s ease-in-out infinite" }}>⭐</Box>
      <Box sx={{ position: "absolute", top: "20%", right: "45%", fontSize: "40px", opacity: 0.05, animation: "floatY 3.5s ease-in-out infinite" }}>📚</Box>

      {/* Decorative dots pattern */}
      {[0, 1, 2, 3, 4].map(i => [0, 1, 2, 3, 4].map(j => (
        <Box
          key={`${i}-${j}`}
          sx={{
            position: "absolute",
            top: 40 + i * 30,
            right: 40 + j * 30,
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: `rgba(27,31,59,${0.04 + i * 0.02})`,
          }}
        />
      )))}

      <Container maxWidth="xl" sx={{ position: "relative" }}>
        <Grid container spacing={{ xs: 5, md: 8 }}>
          {/* Left text - FIXED HEIGHT with overflow hidden */}
          <Grid item xs={12} md={6}>
            <Box sx={{
              height: { xs: "auto", md: "520px" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              position: "relative",
            }}>
              {/* Content area with fixed structure */}
              <Box sx={{ position: "relative", width: "100%" }}>

                {/* Badge - Fixed position */}
                <Box sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 0.75,
                  mb: 3,
                  borderRadius: "10px",
                  border: `2px solid ${NAVY}`,
                  backgroundColor: "#fff",
                  boxShadow: `3px 3px 0 ${YELLOW}`,
                  transition: "all 0.3s ease",
                  opacity: isTransitioning ? 0.5 : 1,
                }}>
                  <Box sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: TEAL,
                    animation: "blink 1.5s ease-in-out infinite",
                    border: `1.5px solid ${NAVY}`,
                  }} />
                  <Typography sx={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontWeight: 800,
                    fontSize: "0.78rem",
                    letterSpacing: "0.1em",
                    color: NAVY,
                    textTransform: "uppercase"
                  }}>
                    {slide.badge}
                  </Typography>
                </Box>

                {/* Headline - FIXED HEIGHT container with overflow hidden */}
                <Box sx={{
                  height: { xs: "auto", md: "265px" },
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  mb: 2.5,
                }}>
                  <Typography
                    variant="h1"
                    sx={{
                      fontFamily: "'Fredoka One', cursive",
                      fontSize: { xs: "2.2rem", sm: "2.8rem", md: "3rem", lg: "3.5rem" },
                      color: NAVY,
                      lineHeight: 1.15,
                      transition: "opacity 0.4s ease-in-out",
                      opacity: isTransitioning ? 0.3 : 1,
                    }}
                  >
                    {slide.title.split(" ").slice(0, 3).join(" ")}{" "}
                    <Box component="span" sx={{
                      color: CORAL,
                      position: "relative",
                      display: "inline-block",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        bottom: 4,
                        left: 0,
                        right: 0,
                        height: 8,
                        backgroundColor: `${YELLOW}60`,
                        borderRadius: "4px",
                        zIndex: -1,
                      }
                    }}>
                      {slide.title.split(" ").slice(3, 5).join(" ")}
                    </Box>{" "}
                    {slide.title.split(" ").slice(5).join(" ")}
                  </Typography>
                </Box>

                {/* Description - FIXED HEIGHT container with overflow hidden */}
                <Box sx={{
                  height: { xs: "auto", md: "80px" },
                  overflow: "hidden",
                  mb: 4,
                }}>
                  <Typography sx={{
                    color: "#4A4E6D",
                    fontWeight: 600,
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    lineHeight: 1.7,
                    maxWidth: 520,
                    transition: "opacity 0.4s ease-in-out",
                    opacity: isTransitioning ? 0.3 : 1,
                  }}>
                    {slide.description}
                  </Typography>
                </Box>

                {/* CTAs - Fixed position with consistent spacing */}
                <Box sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  height: { md: "52px" },
                  alignItems: "center",
                }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => onNavigate("admissions")}
                    sx={{
                      px: { xs: 3, md: 4 },
                      py: 1.5,
                      fontSize: "1rem",
                      fontWeight: 800,
                      backgroundColor: CORAL,
                      color: "#fff",
                      border: `2.5px solid ${NAVY}`,
                      boxShadow: `4px 4px 0 ${NAVY}`,
                      fontFamily: "'Space Grotesk', sans-serif",
                      borderRadius: "12px",
                      transition: "all 0.2s ease",
                      flexShrink: 0,
                      "&:hover": {
                        backgroundColor: "#FF8080",
                        transform: "translate(-2px,-2px)",
                        boxShadow: `6px 6px 0 ${NAVY}`,
                      }
                    }}
                  >
                    Apply Now 🎒
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    onClick={() => onNavigate("about")}
                    sx={{
                      px: { xs: 3, md: 4 },
                      py: 1.5,
                      fontSize: "1rem",
                      fontWeight: 800,
                      borderColor: NAVY,
                      color: NAVY,
                      backgroundColor: "#fff",
                      border: `2.5px solid ${NAVY}`,
                      boxShadow: `4px 4px 0 ${TEAL}`,
                      fontFamily: "'Space Grotesk', sans-serif",
                      borderRadius: "12px",
                      transition: "all 0.2s ease",
                      flexShrink: 0,
                      "&:hover": {
                        borderColor: NAVY,
                        backgroundColor: `${TEAL}15`,
                        transform: "translate(-2px,-2px)",
                        boxShadow: `6px 6px 0 ${TEAL}`,
                      }
                    }}
                  >
                    Explore School
                  </Button>
                </Box>

                {/* Slide dots - ABSOLUTE positioned to never move */}
                <Box sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  position: "absolute",
                  bottom: { xs: "auto", md: "-40px" },
                  left: 0,
                  mt: { xs: 3, md: 0 },
                }}>
                  {slides.map((_, i) => (
                    <Box
                      key={i}
                      component="button"
                      onClick={() => handleSlideDotClick(i)}
                      sx={{
                        width: i === currentIndex % slides.length ? 28 : 10,
                        height: 10,
                        borderRadius: 999,
                        backgroundColor: i === currentIndex % slides.length ? CORAL : `${NAVY}20`,
                        border: i === currentIndex % slides.length ? `2px solid ${NAVY}` : "none",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        p: 0,
                        "&:hover": {
                          backgroundColor: CORAL,
                          opacity: 0.7,
                        }
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Right - Image Gallery - FIXED HEIGHT */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: { xs: "auto", md: "520px" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* Main image with frame */}
              <Box sx={{
                position: "relative",
                flex: 1,
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}>
                {/* Decorative frame background */}
                <Box sx={{
                  position: "absolute",
                  top: { xs: -12, md: -16 },
                  left: { xs: -12, md: -16 },
                  width: "100%",
                  height: "100%",
                  borderRadius: "28px",
                  border: `4px solid ${NAVY}`,
                  backgroundColor: YELLOW,
                  zIndex: 0,
                }} />

                {/* Image container */}
                <Box sx={{
                  position: "relative",
                  zIndex: 1,
                  width: "100%",
                  borderRadius: "24px",
                  border: `3px solid ${NAVY}`,
                  overflow: "hidden",
                  boxShadow: `8px 8px 0 ${NAVY}`,
                  aspectRatio: "4/3",
                  backgroundColor: "#FFF0E0",
                }}>
                  <Box
                    component="img"
                    src={currentImage.src}
                    alt={currentImage.title}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "all 0.5s ease",
                      transform: isHovered ? "scale(1.05)" : "scale(1)",
                      opacity: isTransitioning ? 0.7 : 1,
                    }}
                  />

                  {/* Image overlay with info */}
                  <Box sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: "linear-gradient(to top, rgba(27,31,59,0.85) 0%, rgba(27,31,59,0.4) 50%, transparent 100%)",
                    p: { xs: 2, md: 3 },
                    pt: { xs: 4, md: 6 },
                    transition: "opacity 0.4s ease-in-out",
                    opacity: isTransitioning ? 0.5 : 1,
                  }}>
                    <Typography sx={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontSize: "0.7rem",
                      fontWeight: 800,
                      color: YELLOW,
                      textTransform: "uppercase",
                      letterSpacing: "0.1em",
                      mb: 0.5,
                    }}>
                      {currentImage.badge}
                    </Typography>
                    <Typography sx={{
                      fontFamily: "'Fredoka One', cursive",
                      fontSize: { xs: "1.1rem", md: "1.3rem" },
                      color: "#fff",
                      textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                    }}>
                      {currentImage.title}
                    </Typography>
                  </Box>

                  {/* Navigation arrows */}
                  <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    right: 0,
                    transform: "translateY(-50%)",
                    display: "flex",
                    justifyContent: "space-between",
                    px: 2,
                    opacity: isHovered ? 1 : 0,
                    transition: "opacity 0.3s ease",
                    pointerEvents: isHovered ? "auto" : "none",
                  }}>
                    <Box
                      onClick={handlePrevImage}
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        border: `2px solid ${NAVY}`,
                        boxShadow: `3px 3px 0 ${NAVY}`,
                        display: "grid",
                        placeItems: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: YELLOW,
                          transform: "scale(1.1) translateX(-2px)",
                        },
                      }}
                    >
                      <ArrowBackRoundedIcon sx={{ color: NAVY }} />
                    </Box>
                    <Box
                      onClick={handleNextImage}
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        border: `2px solid ${NAVY}`,
                        boxShadow: `3px 3px 0 ${NAVY}`,
                        display: "grid",
                        placeItems: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: YELLOW,
                          transform: "scale(1.1) translateX(2px)",
                        },
                      }}
                    >
                      <ArrowForwardRoundedIcon sx={{ color: NAVY }} />
                    </Box>
                  </Box>
                </Box>

                {/* Decorative star badge */}
                <Box sx={{
                  position: "absolute",
                  top: -10,
                  right: -10,
                  zIndex: 2,
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  backgroundColor: CORAL,
                  border: `2.5px solid ${NAVY}`,
                  boxShadow: `3px 3px 0 ${NAVY}`,
                  display: "grid",
                  placeItems: "center",
                  animation: "wiggle 3s ease-in-out infinite",
                }}>
                  <StarRoundedIcon sx={{ color: "#fff", fontSize: 24 }} />
                </Box>
              </Box>

              {/* Thumbnail strip */}
              <Box sx={{
                display: { xs: "none", sm: "flex" },
                gap: 2,
                mt: 3,
                justifyContent: "center",
                height: 56,
                flexShrink: 0,
              }}>
                {HERO_IMAGES.map((img, i) => (
                  <Box
                    key={i}
                    onClick={() => setCurrentIndex(i)}
                    sx={{
                      flex: i === currentIndex % HERO_IMAGES.length ? "0 0 80px" : "0 0 60px",
                      height: 56,
                      borderRadius: "12px",
                      border: i === currentIndex % HERO_IMAGES.length
                        ? `3px solid ${CORAL}`
                        : `2px solid ${NAVY}40`,
                      boxShadow: i === currentIndex % HERO_IMAGES.length
                        ? `3px 3px 0 ${CORAL}`
                        : "none",
                      overflow: "hidden",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      opacity: i === currentIndex % HERO_IMAGES.length ? 1 : 0.6,
                      "&:hover": {
                        opacity: 1,
                        border: `2px solid ${NAVY}`,
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={img.src}
                      alt={img.title}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Stats bar */}
      <Box sx={{
        mt: 8,
        backgroundColor: "#fff",
        py: 3.5,
        borderTop: `3px solid ${YELLOW}40`,
      }}>
        <Container maxWidth="xl">
          <Grid container spacing={3} justifyContent="center">
            {highlights.map((h, i) => (
              <Grid item xs={6} sm={3} key={i}>
                <Box sx={{
                  textAlign: "center",
                  py: 1.5,
                  px: 2,
                  borderRadius: "16px",
                  border: `2px solid ${NAVY}10`,
                  backgroundColor: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    border: `2px solid ${[CORAL, TEAL, YELLOW, PURPLE][i]}40`,
                    backgroundColor: `${[CORAL, TEAL, YELLOW, PURPLE][i]}08`,
                    transform: "translateY(-2px)",
                    boxShadow: `3px 3px 0 ${[CORAL, TEAL, YELLOW, PURPLE][i]}40`,
                  },
                }}>
                  <Typography sx={{
                    fontFamily: "'Fredoka One', cursive",
                    fontSize: "2.2rem",
                    color: [CORAL, TEAL, YELLOW, PURPLE][i % 4],
                    lineHeight: 1,
                    textShadow: `2px 2px 0 ${[CORAL, TEAL, YELLOW, PURPLE][i % 4]}20`,
                  }}>
                    {h.value}+
                  </Typography>
                  <Typography sx={{
                    color: "#4A4E6D",
                    fontWeight: 700,
                    fontSize: "0.82rem",
                    mt: 0.5,
                    fontFamily: "'Space Grotesk', sans-serif",
                  }}>
                    {h.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default HeroSection;